import { Clickable, Col, Row, Text } from 'components';
import { theme } from 'lib';

const TabControl = ({ options, selectedIdx, handleSelect, marg, bg, useFlex }) => {
  return (
    <Col wid="100%" noFlex marg={marg} bg={bg}>
      <Row start between={useFlex}>
        {options.map(
          (x, i) =>
            !!x && (
              <Col noFlex={!useFlex} key={i}>
                <Clickable onClick={() => handleSelect(i)}>
                  <Col centerAll={useFlex} pad="14px 24px 8px">
                    <Text b2 bold col={selectedIdx === i ? '#000' : theme.GREY_60}>
                      {x.title || x}
                    </Text>
                  </Col>

                  {selectedIdx === i && (
                    <Col noFlex wid="100%" ht="4px" marg="0 0 -1px" bg={theme.SECONDARY} />
                  )}
                </Clickable>
              </Col>
            )
        )}
      </Row>

      <Row wid="100%" ht="1px" bg={theme.GREY_20} />
    </Col>
  );
};

export default TabControl;
